import JSONStableStringify from "json-stable-stringify";

import Middleware from "@framework/relay/shared/Middleware";

function methodGETMiddleware(): Middleware {
  return (next) => (ctx) => {
    if (ctx.request.operationKind === "subscription") {
      throw new Error("GraphQL subscriptions are not supported.");
    }

    // Use POST for mutations, otherwise GET.
    ctx.fetchOpts.method =
      ctx.request.operationKind === "mutation" ? "POST" : "GET";

    if (ctx.fetchOpts.method === "GET") {
      // Construct GET URL
      ctx.url += `?id=${ctx.request.id}&variables=${encodeURIComponent(
        // This stringify returns a deterministic result with sorted keys.
        JSONStableStringify(ctx.operation.variables)!,
      )}`;
    }

    return next(ctx);
  };
}

export default methodGETMiddleware;
